<template>
  <v-card flat class="pa-2">
    <!-- v-model="gold.label" -->
    <v-combobox
      v-model="valueComputed"
      :items="items"
      :disabled="loading"
      :loading="loading"
      item-value="asset_id"
      item-text="name"
      :search-input.sync="search"
      persistent-hint
      small-chips
      outlined
      label="انتخاب دارایی"
      hint="برای انتخاب هر کدام از موارد بر روی آن کلیک کنید"
      multiple
      hide-details=""
      dense
      menu-props="top"
    >
      <template v-slot:no-data>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title> موردی برای نمایش وجود ندارد </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <template v-slot:selection></template>
    </v-combobox>

    <v-card v-if="valueComputed.length > 0" class="pa-2 d-flex flex-wrap" flat>
      <v-chip
        v-for="(item, i) in valueComputed"
        :key="i"
        class="ma-2"
        color="gray"
        small
        label
      >
        <span class="pr-2">
          {{ item.name }}
        </span>
        <v-icon @click="deleteHandler(item.asset_id)" small> $delete </v-icon>
      </v-chip>
    </v-card>
  </v-card>
</template>

<script>
export default {
  name: "assetsCom",
  props: {
    value: Array,
    items: Array,
    loading: Boolean,
  },
  data() {
    return {
       search: '', 
    };
  },

  watch: {
    valueComputed: {
      deep: true,
      handler(val) {
        console.log("vaaaa", val);
      },
    },
  },

  computed: {
    valueComputed: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  methods: {
    deleteHandler(id) {
      let aa = this.valueComputed.filter((item) => item.asset_id !== id);
      this.valueComputed = aa;
    },
  },
};
</script>

<style></style>
